import { routesConstants } from '../../_constants';
import { routesServices } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const routesActions = {
    load,
    getRouteByCode,
    createRoute,
    updateRoute,
    deleteRoute,
    activation,
    getRouteDestination,
    getRouteIsActive
};

function routesFetching() { return { type: routesConstants.ROUTES_FETCHING } }
function routesFetched() { return { type: routesConstants.ROUTES_FETCHED } }

function routesSubmitting() { return { type: routesConstants.ROUTES_SUBMITTING } }
function routesSubmitted() { return { type: routesConstants.ROUTES_SUBMITTED } }

function load(skip, take, filter, search) {
    return dispatch => {
        dispatch(routesFetching());
        dispatch(userActions.allowLeavePage());
        routesServices.load(skip, take, filter, search)
            .then(
                routes => {
                    if (routes.length > 0) {
                        dispatch(success(routes));
                        dispatch(routesFetched());
                    } else {
                        dispatch(alertActions.warning(routes.message))
                        dispatch(routesFetched());
                    }
                },
                error => {
                    dispatch(routesFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(routes) { return { type: routesConstants.LIST_OF_ROUTES, routes } }
}

function getRouteByCode(code) {
    return dispatch => {
        dispatch(routesFetching());
        routesServices.getRouteByCode(code)
            .then(
                route => {
                    dispatch(success(route))
                    dispatch(routesFetched());
                },
                error => {
                    dispatch(routesFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(route) { return { type: routesConstants.GET_ROUTE_BY_CODE, route } }
}

function createRoute(payload) {
    return dispatch => {
        dispatch(routesSubmitting());
        dispatch(userActions.notallowLeavePage());
        routesServices.createRoute(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(routesSubmitted());
                    dispatch(alertActions.success('Route added successfully'))
                    window.location.href = '/voyage/routes';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(routesSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function updateRoute(payload, id) {
    return dispatch => {
        dispatch(routesSubmitting());
        dispatch(userActions.notallowLeavePage());
        routesServices.updateRoute(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(routesSubmitted());
                    dispatch(alertActions.success('Route updated successfully'))
                    window.location.href = '/voyage/routes';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(routesSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function deleteRoute(code, type, take) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        routesServices.deleteRoute(code)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Route deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/voyage/routes';
                            break;
                        default:
                            dispatch(load(0, take));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    switch (type) {
                        case "specific":
                            dispatch(getRouteByCode(code));
                            break;
                        default:
                            dispatch(load(0, take));
                            break;
                    }
                }
            );
    };
}

function activation(id, isActive) {
    return dispatch => {
        dispatch(routesSubmitting());
        dispatch(userActions.notallowLeavePage());
        routesServices.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(routesSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getRouteByCode(id));
                    dispatch(alertActions.success(isActive ? 'Route activated successfully' : 'Route deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(routesSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

function getRouteDestination(OriginBranchCode) {
    return dispatch => {
        routesServices.getRouteDestination(OriginBranchCode)
            .then(
                destinationBranches => {
                    if (destinationBranches.length > 0) {
                        dispatch(success(destinationBranches));
                    } else {
                        dispatch(alertActions.warning(destinationBranches.message))
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(destinationBranches) { return { type: routesConstants.DESTINATION_BRANCHES, destinationBranches } }
}

function getRouteIsActive() {
    return dispatch => {
        routesServices.getRouteIsActive()
            .then(
                originBranches => {
                    if (originBranches.length > 0) {
                        dispatch(success(originBranches));
                    } else {
                        dispatch(alertActions.warning(originBranches.message))
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(originBranches) { return { type: routesConstants.ORIGIN_BRANCHES, originBranches } }
}